/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersCreateInInternal } from '../../models/members-create-in-internal';
import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface CreateMemberInternalV2MembersPost$Params {
  org: string;
      body: MembersCreateInInternal
}

export function createMemberInternalV2MembersPost(http: HttpClient, rootUrl: string, params: CreateMemberInternalV2MembersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, createMemberInternalV2MembersPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

createMemberInternalV2MembersPost.PATH = '/_internal/v2/members';
